import React from 'react';

/** Exceute callback function once, when component is mounted */
export const useMount = (callback) => {
    if (isFunction(callback)) {
        React.useEffect(
            callback,
            []
        );
    }
};

/** Execute callback function once, when component is unmounted */
export const useUnmount = (callback) => {
    const callbackRef = React.useRef(callback);
    callbackRef.current = callback;

    React.useEffect(() => {
        return () => {
            if (isFunction(callbackRef.current)) {
                callbackRef.current();
            }
        }
    }, []);
};

/** Test is func an executable function */
export const isFunction = (func) => {
    return func && typeof func === 'function';
}

// ====================

export const pad2 = (value) => {
    return (value ?? 0).toString().padStart(2, 0);
};

export const toMMSS = (secs) => {
    const mins = Math.trunc(secs / 60);
    const padSecs = pad2(secs % 60);
    return `${mins}:${padSecs}`;
};

export const toHHMM = (secs) => {
    const mins = Math.trunc(secs / 60);
    const padHrs = pad2(mins / 60);
    const padMins = pad2(mins % 60);
    return `${padHrs}:${padMins}`;
};